import { config } from 'src/constants';

export const staticBreadCrumbs = [
  {
    id: 'home',
    name: 'homePage',
    url: '/'
  },
  {
    id: 'account',
    name: 'accountPage',
    url: '/store/v2/accounts/dashboard'
  },
  {
    id: 'rnaOligos',
    name: 'rnaOligosPage',
    url: `${config.baseRoute}`
  }
];
